import { User } from "../types"

const checkIsDataIndeterminate = (
  selectedData: string[],
  allData: User[]
): boolean => {
  return !(selectedData.length === 0 || (selectedData.length === 1 && selectedData[0] === '')) && selectedData.length < allData.length
}

export default checkIsDataIndeterminate